
export function isNodeAnHTMLElement(
  node: Node | ChildNode | Element | HTMLElement | Range,
): node is HTMLElement {
  return node instanceof Element && node.nodeType === 1;
}
